/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import cn from "classnames";

import { CommonIconsInterface } from "components/icons/common";

const NextIcon = ({
  size = "small",
  className,
  ...rest
}: CommonIconsInterface) => {
  let iconSizeClassName;
  if (size === "small") {
    iconSizeClassName = "w-5 h-4";
  } else {
    iconSizeClassName = "w-7 h-7";
  }

  return (
    <svg
      className={cn(iconSizeClassName, className)}
      fill={rest.color || "currentColor"}
      stroke={rest.color || "currentColor"}
      viewBox="0 0 15 15"
      test-id="s-vWZjZV"
    >
      <path
        fillRule="evenodd"
        d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
        test-id="pTlM-xWP"
      />
    </svg>
  );
};

export default NextIcon;
